export default __webpack_public_path__ + "static/media/incorrect8.bf65d9ba.mp3";